import { InteractionRequiredAuthError } from '@azure/msal-browser'

import { apiTokenRequest } from '@/authConfig'
import { PATH } from '@/const'
import { msalInstance, msalTracking } from '@/msalInstance'

import { Api } from './generated-api'

const api = new Api({
  customFetch: async (input, init) => {
    const account = msalInstance.getAllAccounts()[0]

    if (account) {
      const accessTokenRequest = {
        ...apiTokenRequest,
        account
      }
      let accessTokenResponse
      try {
        await msalTracking.initializingPromise
        accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest)
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          accessTokenResponse = await msalInstance.acquireTokenPopup(accessTokenRequest)
        }
      }
      init = init ?? {}
      const headers: any = init.headers ?? {}
      if (accessTokenResponse?.accessToken) {
        headers.Authorization = `Bearer ${accessTokenResponse.accessToken}`
      }
      init.headers = headers
    }

    return fetch(input, init)
      .then(response => {
        if (response?.status === 401) {
          window.location.replace(PATH.logout)
        }
        return response
      })
      .catch(e => {
        if (e.status === 401) {
          window.location.replace(PATH.logout)
        }
        return Promise.reject(e)
      })
  }
})

if (window) {
  const { host, protocol } = window.location
  api.baseUrl = `${protocol}//${host}/api`
}

// if (process.env.STORYBOOK === 'true') {
//   api.baseUrl = 'http://localhost:9001/api'
//   api.setSecurityData({
//     headers: {
//       credentials: 'omit'
//     }
//   })
// }
export default api
